import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useIndustryNames = (config) => {
  return useQuery({
    ...config,
    queryKey: "industry-names",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/messaging/industry-names`,
        signal,
      }),
  });
};

export const useIndustries = (config) => {
  return useQuery({
    ...config,
    queryKey: "industries",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/messaging/industries`,
        signal,
      }),
  });
};
